import { Pipe, PipeTransform } from '@angular/core';
import { PostingTypeEnum } from 'app/library/posting/models/posting-type.enum';

@Pipe({
    name: 'getPostingIcon',
})
export class GetPostingIconPipe implements PipeTransform {
    transform(type: string): string {
        switch (type) {
            case PostingTypeEnum.Program:
                return 'program';
            case PostingTypeEnum.E_learning:
                return 'e_learning';
            case PostingTypeEnum.Course:
                return 'course';
            default:
                return '';
        }
    }
}
